var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickingQueue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "picking que empty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "169.961462%",
    y1: "-324.053889%",
    x2: "38.5316377%",
    y2: "125.542689%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44C0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9F9F0",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-2",
    points: "0 72.0034042 81.4268739 72.0034042 81.4268739 63.5799345 0 63.5799345"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "2.80782324 76.2151391 14.0391162 76.2151391 14.0391162 71.0875329 2.80782324 71.0875329"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-4",
    points: "67.3877577 76.2151391 78.6190507 76.2151391 78.6190507 71.0875329 67.3877577 71.0875329"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "35.0977905 76.2151391 46.3290834 76.2151391 46.3290834 71.0875329 35.0977905 71.0875329"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.713437,22.8664975 L30.8860556,22.8664975 L30.8860556,36.9056137 L23.8664975,31.2899672 L16.8469394,36.9056137 L16.8469394,22.8664975 L7.0195581,22.8664975 C3.91831733,22.8664975 1.40391162,25.3809032 1.40391162,28.482144 L1.40391162,59.3681996 C1.40391162,62.4694404 3.91831733,64.9838461 7.0195581,64.9838461 L40.713437,64.9838461 C43.8146777,64.9838461 46.3290834,62.4694404 46.3290834,59.3681996 L46.3290834,28.482144 C46.3290834,25.3809032 43.8146777,22.8664975 40.713437,22.8664975 Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0034042,29.8860556 L65.9838461,29.8860556 L65.9838461,39.713437 L61.7721113,36.9056137 L57.5603764,39.713437 L57.5603764,29.8860556 L44.9251718,29.8860556 L44.9251718,59.3681996 C44.9251718,62.4694404 42.4107661,64.9838461 39.3095253,64.9838461 L57.5603764,64.9838461 L65.9838461,64.9838461 L73.0034042,64.9838461 C76.104645,64.9838461 78.6190507,62.4694404 78.6190507,59.3681996 L78.6190507,35.5017021 C78.6190507,32.4004613 76.104645,29.8860556 73.0034042,29.8860556 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5212602,0.40391162 L43.5212602,10.231293 L39.3095253,7.42346972 L35.0977905,10.231293 L35.0977905,0.40391162 L29.482144,0.40391162 C26.3809032,0.40391162 23.8664975,2.91831733 23.8664975,6.0195581 L23.8664975,22.8664975 L30.8860556,22.8664975 L30.8860556,24.2704092 L39.3095253,24.2704092 C42.4107661,24.2704092 44.9251718,26.7848149 44.9251718,29.8860556 L44.9251718,31.2899672 L49.1369067,31.2899672 C52.2381475,31.2899672 54.7525532,28.7755615 54.7525532,25.6743208 L54.7525532,6.0195581 C54.7525532,2.91831733 52.2381475,0.40391162 49.1369067,0.40391162 L43.5212602,0.40391162 Z",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.144601,1.54559077 L32.3584507,1.54559077 L32.3584507,17.0014985 L24.6540577,10.8191354 L16.9496647,17.0014985 L16.9496647,1.54559077 L6.16351443,1.54559077 C2.75971358,1.54559077 0,4.31374385 0,7.72795387 L0,41.7309509 C0,45.1451609 2.75971358,47.913314 6.16351443,47.913314 L43.144601,47.913314 C46.5484018,47.913314 49.3081154,45.1451609 49.3081154,41.7309509 L49.3081154,7.72795387 C49.3081154,4.31374385 46.5484018,1.54559077 43.144601,1.54559077 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3390099,1.19432014 L25.0042574,1.19432014 L25.0042574,13.1375216 L19.0508628,8.360241 L13.0974682,13.1375216 L13.0974682,1.19432014 L4.76271569,1.19432014 C2.13250595,1.19432014 0,3.33334752 0,5.97160072 L0,32.2466439 C0,34.8848971 2.13250595,37.0239244 4.76271569,37.0239244 L33.3390099,37.0239244 C35.9692196,37.0239244 38.1017256,34.8848971 38.1017256,32.2466439 L38.1017256,5.97160072 C38.1017256,3.33334752 35.9692196,1.19432014 33.3390099,1.19432014 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3390099,0.194320143 L25.0042574,0.194320143 L25.0042574,12.1375216 L19.0508628,7.360241 L13.0974682,12.1375216 L13.0974682,0.194320143 L4.76271569,0.194320143 C2.13250595,0.194320143 0,2.33334752 0,4.97160072 L0,31.2466439 C0,33.8848971 2.13250595,36.0239244 4.76271569,36.0239244 L33.3390099,36.0239244 C35.9692196,36.0239244 38.1017256,33.8848971 38.1017256,31.2466439 L38.1017256,4.97160072 C38.1017256,2.33334752 35.9692196,0.194320143 33.3390099,0.194320143 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-12",
    x: 1.21378025,
    y: 2.61755893,
    width: 18.2347574,
    height: 8.51929635,
    rx: 4.25964817
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-13",
    cx: 64.3525852,
    cy: 108.96415,
    rx: 6.93395373,
    ry: 6.95515848
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path-14",
    cx: 121.365094,
    cy: 93.5082418,
    rx: 6.93395373,
    ry: 6.95515848
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "resized-illustrations_version-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "picking-que-empty"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    x: 0,
    y: 0,
    width: 300,
    height: 300
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1.000000, 40.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.254584,111.741573 C263.589504,172.19705 214.411011,221 153.842324,221 C92.8595457,221 43.4232365,171.527465 43.4232365,110.5 C43.4232365,105.447329 43.7621099,100.473863 44.4183532,95.6011236 L9.93258427,95.6011236 C4.44696945,95.6011236 6.71794063e-16,91.1541541 0,85.6685393 C-6.71794063e-16,80.1829245 4.44696945,75.7359551 9.93258427,75.7359551 L48.9985591,75.7359551 L88.0798639,75.7359551 C93.5654787,75.7359551 98.0124481,71.2889856 98.0124481,65.8033708 C98.0124481,61.5361533 95.3215139,57.8974372 91.543996,56.491573 C90.4654202,56.8929824 89.2982612,57.1123596 88.0798639,57.1123596 L42.1898457,57.1123596 C36.7042309,57.1123596 32.2572614,52.6653901 32.2572614,47.1797753 C32.2572614,41.6941605 36.7042309,37.247191 42.1898457,37.247191 L71.1710885,37.247191 C91.4001989,14.4006708 120.940764,0 153.842324,0 C201.299058,0 241.763324,29.9602512 257.37869,72.011236 L289.067416,72.011236 C294.553031,72.011236 299,76.4582054 299,81.9438202 C299,87.429435 294.553031,91.8764045 289.067416,91.8764045 L262.699818,91.8764045 L240.69607,91.8764045 C235.210455,91.8764045 230.763485,96.3233739 230.763485,101.808989 C230.763485,107.294604 235.210455,111.741573 240.69607,111.741573 L264.254584,111.741573 Z",
    id: "Combined-Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(78.000000, 109.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(0.000000, 43.818279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M0.5,71.5034042 L80.9268739,71.5034042 L80.9268739,64.0799345 L0.5,64.0799345 L0.5,71.5034042 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M3.30782324,75.7151391 L13.5391162,75.7151391 L13.5391162,71.5875329 L3.30782324,71.5875329 L3.30782324,75.7151391 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M67.8877577,75.7151391 L78.1190507,75.7151391 L78.1190507,71.5875329 L67.8877577,71.5875329 L67.8877577,75.7151391 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M35.5977905,75.7151391 L45.8290834,75.7151391 L45.8290834,71.5875329 L35.5977905,71.5875329 L35.5977905,75.7151391 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M31.3860556,23.3664975 L31.3860556,37.9459262 L23.8664975,31.9302797 L16.3469394,37.9459262 L16.3469394,23.3664975 L7.0195581,23.3664975 C4.19445971,23.3664975 1.90391162,25.6570456 1.90391162,28.482144 L1.90391162,59.3681996 C1.90391162,62.193298 4.19445971,64.4838461 7.0195581,64.4838461 L40.713437,64.4838461 C43.5385354,64.4838461 45.8290834,62.193298 45.8290834,59.3681996 L45.8290834,28.482144 C45.8290834,25.6570456 43.5385354,23.3664975 40.713437,23.3664975 L31.3860556,23.3664975 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.0977905,59.3681996 L40.713437,59.3681996",
    id: "Shape",
    stroke: "#64808C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2899672,53.7525532 L40.713437,53.7525532",
    id: "Shape",
    stroke: "#64808C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5994926,60.7721113 L74.4073158,60.7721113",
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7916694,56.5603764 L74.4073158,56.5603764",
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M66.4838461,30.3860556 L66.4838461,40.6476955 L61.7721113,37.5065389 L57.0603764,40.6476955 L57.0603764,30.3860556 L45.4251718,30.3860556 L45.4251718,59.3681996 C45.4251718,61.5078307 44.3261854,63.3909546 42.6619379,64.4838461 L73.0034042,64.4838461 C75.8285026,64.4838461 78.1190507,62.193298 78.1190507,59.3681996 L78.1190507,35.5017021 C78.1190507,32.6766037 75.8285026,30.3860556 73.0034042,30.3860556 L66.4838461,30.3860556 Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#EB8181",
    points: "67.3877577 42.5212602 61.7721113 39.0114812 56.1564648 42.5212602 56.1564648 29.8672432 67.3877577 29.8672432"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1,
    d: "M44.0212602,0.90391162 L44.0212602,11.1655515 L39.3095253,8.02439493 L34.5977905,11.1655515 L34.5977905,0.90391162 L29.482144,0.90391162 C26.6570456,0.90391162 24.3664975,3.19445971 24.3664975,6.0195581 L24.3664975,22.3664975 L31.3860556,22.3664975 L31.3860556,23.7704092 L39.3095253,23.7704092 C42.6869085,23.7704092 45.4251718,26.5086725 45.4251718,29.8860556 L45.4251718,30.7899672 L49.1369067,30.7899672 C51.9620051,30.7899672 54.2525532,28.4994192 54.2525532,25.6743208 L54.2525532,6.0195581 C54.2525532,3.19445971 51.9620051,0.90391162 49.1369067,0.90391162 L44.0212602,0.90391162 Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#EB8181",
    points: "44.9251718 13.0391162 39.3095253 9.52933715 33.6938789 13.0391162 33.6938789 0.202458152 44.9251718 0.202458152"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(41.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(68.458726, 74.764719) rotate(-15.000000) translate(-68.458726, -74.764719) translate(43.763604, 50.544535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1.1,
    d: "M32.9084507,2.09559077 L32.9084507,18.1480291 L24.6540577,11.5243204 L16.3996647,18.1480291 L16.3996647,2.09559077 L6.16351443,2.09559077 C3.06384678,2.09559077 0.55,4.61712515 0.55,7.72795387 L0.55,41.7309509 C0.55,44.8417796 3.06384678,47.363314 6.16351443,47.363314 L43.144601,47.363314 C46.2442686,47.363314 48.7581154,44.8417796 48.7581154,41.7309509 L48.7581154,7.72795387 C48.7581154,4.61712515 46.2442686,2.09559077 43.144601,2.09559077 L32.9084507,2.09559077 Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#87D5FA",
    points: "33.8993293 20.0926801 24.6540577 12.7862509 15.4087861 20.0926801 15.4087861 0 33.8993293 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9810866,41.7309509 L43.144601,41.7309509",
    id: "Shape",
    stroke: "#64808C",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8993293,35.5485878 L43.144601,35.5485878",
    id: "Shape",
    stroke: "#64808C",
    strokeWidth: 1.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(53.171122, 38.038839) rotate(-15.000000) translate(-53.171122, -38.038839) translate(33.671122, 19.038839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1.1,
    d: "M25.5542574,1.74432014 L25.5542574,14.2840522 L19.0508628,9.06542602 L12.5474682,14.2840522 L12.5474682,1.74432014 L4.76271569,1.74432014 C2.43663914,1.74432014 0.55,3.63672882 0.55,5.97160072 L0.55,32.2466439 C0.55,34.5815158 2.43663914,36.4739244 4.76271569,36.4739244 L33.3390099,36.4739244 C35.6650864,36.4739244 37.5517256,34.5815158 37.5517256,32.2466439 L37.5517256,5.97160072 C37.5517256,3.63672882 35.6650864,1.74432014 33.3390099,1.74432014 L25.5542574,1.74432014 Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#EB8181",
    points: "26.1949363 15.5261619 19.0508628 9.88028482 11.9067892 15.5261619 11.6554667 0.937948304 25.9436138 0.937948304"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(111.697837, 68.868359) rotate(-15.000000) translate(-111.697837, -68.868359) translate(92.197837, 50.368359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeWidth: 1.1,
    d: "M25.5542574,0.744320143 L25.5542574,13.2840522 L19.0508628,8.06542602 L12.5474682,13.2840522 L12.5474682,0.744320143 L4.76271569,0.744320143 C2.43663914,0.744320143 0.55,2.63672882 0.55,4.97160072 L0.55,31.2466439 C0.55,33.5815158 2.43663914,35.4739244 4.76271569,35.4739244 L33.3390099,35.4739244 C35.6650864,35.4739244 37.5517256,33.5815158 37.5517256,31.2466439 L37.5517256,4.97160072 C37.5517256,2.63672882 35.6650864,0.744320143 33.3390099,0.744320143 L25.5542574,0.744320143 Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#87D5FA",
    points: "26.1949363 14.5261619 19.0508628 8.88028482 11.9067892 14.5261619 11.6319932 0.0255527541 25.9201403 0.0255527541"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.8549117,103.656591 C64.3572079,103.656591 63.8595041,103.723051 63.3710456,103.851335 L63.3417689,103.859063 C60.2707978,104.692137 58.4433158,107.876054 59.2676858,110.964144 C59.9425907,113.495822 62.2323363,115.263978 64.8364211,115.267069 L64.8518299,115.267069 C65.3510746,115.265523 65.853401,115.199063 66.3434004,115.067688 C69.4220758,114.239251 71.2557214,111.050697 70.4298105,107.95797 C69.7533647,105.424747 67.4605374,103.656591 64.8549117,103.656591 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6145949,4.35083803 C15.6145949,4.34929244 15.6145949,4.34774685 15.6145949,4.34774685 C15.2771425,3.081908 14.1261062,2.19783008 12.8148185,2.19783008 C12.566737,2.19783008 12.3186556,2.23028749 12.0767376,2.29674789 L3.70514414,4.54867365 C2.16580641,4.96289197 1.24898364,6.55794165 1.66193911,8.10507802 C1.66502087,8.11435156 1.66656174,8.1251707 1.6696435,8.13444424 C2.01634119,9.38482718 3.16121399,10.2565404 4.46171554,10.2565404 C4.70979699,10.2565404 4.95787845,10.2225374 5.19979639,10.1576226 L13.5713899,7.90569681 C15.1091867,7.48993289 16.0260095,5.89797439 15.6145949,4.35083803 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.677862,88.6396309 C120.180158,88.6396309 119.679372,88.7060913 119.190914,88.8359209 L119.167801,88.8421033 C116.09683,89.6736311 114.267807,92.8590937 115.092177,95.9487296 C115.768623,98.4819529 118.059909,100.251654 120.667076,100.251654 C121.169402,100.251654 121.67481,100.183648 122.167891,100.052273 C125.246567,99.2238365 127.080212,96.0352827 126.254301,92.9425556 C125.577856,90.4077867 123.285028,88.6396309 120.677862,88.6396309 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0267262,4.73843586 L24.1640964,3.19284509 L49.7675145,98.6227634 C50.5546424,101.556573 53.5710581,103.296802 56.5048675,102.509674 C56.5134296,102.507377 56.5219861,102.505059 56.5305369,102.502721 L133.439899,81.4691077",
    id: "Path-23",
    stroke: "#64808C",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-28",
    transform: "translate(10.331159, 6.877207) rotate(-18.000000) translate(-10.331159, -6.877207) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#64808C",
    strokeWidth: 1.1,
    x: 1.76378025,
    y: 3.16755893,
    width: 17.1347574,
    height: 7.41929635,
    rx: 3.70964817
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-19"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#64808C",
    strokeWidth: 1.1,
    cx: 64.3525852,
    cy: 108.96415,
    rx: 6.38395373,
    ry: 6.40515848
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-19-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#64808C",
    strokeWidth: 1.1,
    cx: 121.365094,
    cy: 93.5082418,
    rx: 6.38395373,
    ry: 6.40515848
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50,119.55 L83.5055498,119.55",
    id: "Path-24",
    stroke: "#64808C",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2379577,119.237694 L90.8605935,119.237694",
    id: "Path-24",
    stroke: "#64808C",
    strokeWidth: 1.1
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#87D5FA",
    points: "110.846939 192.250851 102.42347 185.614178 94 192.250851 94 174.983548 110.846939 174.983548"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickingQueue);
export default __webpack_public_path__ + "static/media/picking-queue.ac3ccd5b884cc67a6b0e035e2ab5db19.svg";
export { ForwardRef as ReactComponent };